module.exports = __webpack_public_path__ + "img/66.2e3779d4.jpg";